import type { DetailedHTMLProps, HTMLAttributes } from 'react';

declare global {
  interface HTMLElementTagNameMap {
    'pega-connected-watcher': PegaConnectedWatcher;
  }

  namespace JSX {
    interface IntrinsicElements {
      'pega-connected-watcher': DetailedHTMLProps<
        HTMLAttributes<PegaConnectedWatcher>,
        PegaConnectedWatcher
      >;
    }
  }
}

class PegaConnectedWatcher extends HTMLElement {
  connectedCallback() {
    this.dispatchEvent(new Event('connect-disconnect', { bubbles: false }));
  }

  disconnectedCallback() {
    this.dispatchEvent(new Event('connect-disconnect', { bubbles: false }));
  }
}

if (!customElements.get('pega-connected-watcher')) {
  customElements.define('pega-connected-watcher', PegaConnectedWatcher);
}

export default PegaConnectedWatcher;
